const Config = () => {
  const env = process.env.NODE_ENV;
  const version = process.env.npm_package_version;

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const appSecret = process.env.REACT_APP_SECRET;

  const fbEvent = process.env.REACT_APP_FB_EVENT_ENV;
  return {
    env,
    version,
    fbEvent,
    baseUrl,
    apiUrl,
    appSecret,
  };
};

export default Config();
